module.exports = "<div class=\"loading-screen-wrapper\" *ngIf=\"loading\">\n\t<mat-spinner></mat-spinner>\n</div>\n\n"